import { AppState } from 'redux/reducers';

export const getCollapse = (state: AppState) => state.collapse;

export const getOpenedStateByGroup =
  (group: string, type: string) =>
  ({ collapse }: AppState) =>
    collapse[group]?.[type]?.openedState ?? true;
